module.exports = __webpack_public_path__ + "static/img/main1.a5ef2f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/main1.png
// module id = yudq
// module chunks = 1